<template>
  <v-container fluid full-height grid-list-md>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y>
            <template v-slot:activator="{on,attrs}">
              <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-form ref="from" v-model="valid" lazy-validation>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm3>
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="queryParams.yearMonth"
                  lazy
                  transition="scale-transition"
                  offest-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="queryParams.yearMonth"
                      label="Month"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="queryParams.yearMonth" type="month" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="$refs.menu.save(queryParams.yearMonth)">Ok</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm3>
                <v-text-field
                  name="code"
                  label="Finance Session Code"
                  v-model="queryParams.code"
                  type="text"
                ></v-text-field>
              </v-flex>
              <v-flex sm3>
                <v-select
                  :items="shopList"
                  label="Choose Shop..."
                  item-text="name"
                  menu-props="auto"
                  item-value="id"
                  :readonly="user.role.roleName == 'BRANCH_ADMIN'"
                  v-model="queryParams.shopId"
                ></v-select>
              </v-flex>
              <v-flex sm3>
                <v-btn outline color="primary" @click="onSearch">
                  Search
                  <v-icon right>search</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
         </v-card>
       </v-form>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="financeSessionList"
            class="elevation-1"
            :loading="showListLoading"
            :total:items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :paginaton.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.code}}</td>
              <td>{{ props.item.yearMonth}}</td>
              <td>{{ props.item.shopName}}</td>
              <td>{{ props.item.financialYearName}}</td>
              <td>
                <v-btn color="info" @click="run(props.item)">Run</v-btn>
              </td>
              <td>
                <v-btn color="info" @click="reverse(props.item)">Reverse</v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <div class="text-xs-center">
      <v-dialog v-model="dialog" persistent max-width="360">
        <v-card>
          <v-card-title class="headline green lighten-2">Process Info</v-card-title>
          <v-card-text>{{responseMessage}}</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="dialogDisabled" flat @click="dialog = false">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- confrim dialog for reverse process-->
    <v-dialog
      v-model="reverseConfirmBox"
      max-width="500px"
      @keydown.enter="onReverse()"
      @keydown.esc="open = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>Are you sure to reverse this finance session?</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="reverseConfirmBox=false">No</v-btn>
          <v-btn
            color="success"
            large
            outline
            :loading="reverseProcessing"
            @click="onReverse(),reverseConfirmBox = false"
          >yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- confrim dialog for run process-->
    <v-dialog
      v-model="runConfirmBox"
      max-width="500px"
      @keydown.enter="onRun()"
      @keydown.esc="open = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>Are you sure to run this finance session?</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="runConfirmBox=false">No</v-btn>
          <v-btn
            color="success"
            large
            outline
            :loading="runProcessing"
            @click="onRun(),runConfirmBox=false"
          >yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { shopService } from "../../services/shop-service";
import { financeSessionService } from "../../services/finance-session-service";
import Loading from "vue-loading-overlay";

export default {
  name: "FinanceSessionList",
  components: { Loading },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    dialog: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "Finance",
        disabled: true,
      },
      {
        text: "Finance Sessions",
        disabled: true,
      },
    ],
    valid: true,
    queryParams: {
      yearMonth: new Date().toISOString().substr(0, 7),
      shopId: "",
      code: "",
    },
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    rowsPerPageItems: [25, 50, 100],
    responseError: "",
    responseMessage: "",
    financeSession: "",
    menu: false,
    isLoading: false,
    totalRows: 0,
    showListLoading: false,
    fullPage: true,
    dialogDisabled: false,
    reverseConfirmBox: false,
    runConfirmBox: false,
    reverseProcessing: false,
    runProcessing: false,
    shopList: [],
    financeSessionList: [],
    headers: [
      { text: "Action", sortable: false },
      { text: "Finance Session Code", align: "left", value: "code" },
      { text: "YearMonth", value: "yearMonth" },
      { text: "Shop Name", value: "shopName" },
      { text: "Finance Year Name", value: "financialYearName" },
      { text: "Run", align: "center", sortable: false },
      { text: "Reverse", align: "center", sortable: false },
    ],
  }),
  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.shopId = this.user.shopId;
    }
    this.getAllShop();
    this.onSearch();
    if (this.$route.query.shopId) {
      this.queryParams.shopId = this.$route.query.shopId;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.yearMonth) {
      this.queryParams.yearMonth = this.$route.query.yearMonth;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "finance-sessions",
        query: this.queryParams,
      });
      this.getFinanceSessionList();
    },
    getFinanceSessionList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      financeSessionService
        .getAllFinanceSession(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.financeSessionList = res.data.financeSessionDTOs;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getAllShop() {
      shopService
        .getAllShop()
        .then((res) => {
          this.shopList = res.data;
          let findAll = {
            id: "",
            name: "--- ALL ---",
          };
          this.shopList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    onRegister() {
      this.$router.push("/finance-sessions/new");
    },
    onEdit(financeSession) {
      this.$router.push("/finance-sessions/" + financeSession.id);
    },
    onRun() {
      this.isLoading = true;
      this.dialog = true;
      this.responseMessage = "Loading Process.....";
      this.dialogDisabled = true;
      financeSessionService
        .runProcess(this.financeSession.id)
        .then((res) => {
          if (res.data) {
            this.responseMessage = "Process Success";
            this.dialogDisabled = false;
          }
        })
        .catch((err) => {
          if (err.response) {
            this.dialogDisabled = false;
            if (err.response.data) {
              this.responseMessage = err.response.data.message;
            }
          } else {
            this.responseMessage = "Loading Process.....";
            console.log("Timeout error");
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.dialog = true;
          this.dialogDisabled = false;
        });
    },
    reverse(financeSession) {
      if (!this.reverseProcessing) {
        //   this.reverseProcessing = true;
        this.reverseConfirmBox = true;
      }
      this.financeSession = financeSession;
    },
    run(financeSession) {
      if (!this.runProcessing) {
        this.runConfirmBox = true;
      }
      this.financeSession = financeSession;
    },
    onReverse() {
      this.isLoading = true;
      this.dialog = true;
      this.responseMessage = "Loading Process.....";
      this.dialogDisabled = true;
      financeSessionService
        .reverseProcess(this.financeSession.id)
        .then((res) => {
          if (res.data) {
            this.responseMessage = "Process Success";
            this.dialogDisabled = false;
          }
        })
        .catch((err) => {
          this.dialogDisabled = false;
          if (err.response.data) {
            this.responseMessage = err.response.data.message;
          }
        })
        .finally(() => {
          this.isLoading = false;
          this.dialog = true;
          this.dialogDisabled = false;
        });
    },
  },
};
</script>